__turbopack_context__.v({
  "badge": "badge-module-scss-module__-L31Xq__badge",
  "badge--destructive": "badge-module-scss-module__-L31Xq__badge--destructive",
  "badge--neutral": "badge-module-scss-module__-L31Xq__badge--neutral",
  "badge--success": "badge-module-scss-module__-L31Xq__badge--success",
  "badge--warning": "badge-module-scss-module__-L31Xq__badge--warning",
});
